import { createSlice } from "@reduxjs/toolkit";
import { customStyles } from "../styles";
import { labelStatus } from "../utils/labelStatus";

const stateDefault = {
  account: null,
  service: null,
  quantity: 0,
  paymentMethod: null,
  isByCost: true,
  subTotal: 0,
  scheduleSelected: {
    date: null,
    time: null
  },
  orderHistory: null,
  trackingOrder: null,
  activeOrders: null,
  folio: null
}
export const orderSlice = createSlice({
  name: 'order',
  initialState: stateDefault,
  reducers: {
    setAccount: (state, { payload }) => {
      state.account = payload
    },
    resetOrder: (state) => {
      
      return {
        ...state,
        account: null,
        service: null,
        quantity: 0,
        paymentMethod: null,
        isByCost: true,
        subTotal: 0,
        scheduleSelected: {
          date: null,
          time: null
        },
        folio: null
      }
    },
    fullOrderReset: (state) => {
      return stateDefault
    },
    setService: ( state, { payload } ) => {
      state.service = payload
    },
    setQuantity: ( state, { payload } ) => {
      state.quantity = payload
    },
    setQuantityLiters: ( state, { payload } ) => {
      const { isByCost, qt, switched } = payload;
      
      (isByCost)
        ? state.quantity = (qt / state?.service?.price).toFixed(2)
        : state.quantity = qt 
    },
    setSubTotal: ( state,  ) => {
      state.subTotal = state.service?.price * state.quantity || 0
    },
    setSubTotalEstacionario: ( state,  { payload }) => {

      (state.isByCost)
        ? state.subTotal = payload
        : state.subTotal = (state.service?.price * state.quantity).toFixed(2) || 0
    },
    setSchedule: (state, {payload}) => {
      payload?.id ? state.scheduleSelected.time = payload : state.scheduleSelected.date = payload
    },
    cancelSchedule: (state) => {
      state.scheduleSelected.time = null;
      state.scheduleSelected.date = null;
    },
    setPaymentMethod: (state, {payload}) => {
      state.paymentMethod = payload
    },
    setIsbyCost: ( state, { payload }) => {
      state.isByCost = payload
    },
    resetService: (state) => {
      return stateDefault
    },
    getHistory: (state, { payload }) => {
      state.orderHistory = payload.services.map(item => {
        return {
          ...item, 
          statusLabel: labelStatus(item.status),
          colorStatus: item.status !== 'CANCELED' ? customStyles.colors.success : customStyles.colors.red
        }
      }).filter(item => item.status === 'CANCELED' || item.status === 'DONE')
      state.activeOrders = payload.services.filter(item => item.status !== 'CANCELED' && item.status !== 'DONE').sort((a, b) => {
        return a.date > b.date ? -1 : 1
      })
    },
    getTrackingOrder: (state, { payload }) => {
      state.trackingOrder = payload
    },
    addOrderId: (state, { payload }) => {
      state.id = payload;
    },
    addOrderQuantity: (state, { payload }) => {
      
      const { byCost, quantity, capacity, price, index } = payload
      
      if(byCost){
        let lts = quantity / state.data[0].price;
        // const price = state.data[0].price
        // 
        state.productToBuy.qt = lts.toFixed(2);
        state.productToBuy.subTotal =  quantity.toFixed(2);
      } else {
        let newSubtotal = quantity * state.data[0].price
        
        state.productToBuy.qt = quantity;
        state.productToBuy.subTotal =  newSubtotal.toFixed(2);
      }
    },
    setFolio: (state, { payload }) => {
      state.folio = payload
    },
    cancelOrder: (state, {payload}) => {
      state.activeOrders = state.activeOrders.filter(order => order.id !== payload)
    }
  }
})

export const { addOrderId, addOrderQuantity, resetOrder,setService, setQuantity, setSubTotal, resetService, setIsbyCost, setQuantityLiters, setSubTotalEstacionario, setAccount, setSchedule, cancelSchedule, setPaymentMethod, getHistory, getTrackingOrder, setFolio,  fullOrderReset, cancelOrder} = orderSlice.actions